"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var job_def_1 = require("../../../shared/job.def");
var response = joi_1.default.object({
    results: joi_1.default.array().items(job_def_1.job),
});
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/job.json', {
    description: 'Get a list of jobs within a department',
    method: 'get',
    summary: 'Job list',
    tags: ['Job'],
    params: [
        {
            $ref: '#/components/parameters/ikeDepartmentId',
        },
    ],
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: response,
    },
    (0, api_response_def_1.generateValidationError)(),
]);
//# sourceMappingURL=job.list.get.schema.js.map